import React from 'react';
import { stats } from '../../data/content';
export function Stats() {
  return <section aria-label="Key numbers" className="w-full bg-bone-50 px-5 py-10 sm:py-12" data-id="element-200" data-mp="2fgggcrp3dspg">
      <ul className="mx-auto grid w-full max-w-xl grid-cols-2 gap-x-4 gap-y-8 lg:max-w-5xl lg:grid-cols-4" data-id="element-201" data-mp="2ah3jde4ib595">
        {stats.map(stat => <li key={stat.label} className="flex flex-col items-center text-center" data-id="element-202" data-mp="26gjl27875vlf">
            <span className="font-display text-3xl font-bold leading-none text-ink-900 sm:text-4xl" data-id="element-203" data-mp="33610vf0w8y0u">
              {stat.value}
            </span>
            <span className="mt-2 max-w-[11rem] text-[11px] font-semibold uppercase leading-snug tracking-[0.08em] text-ink-900/50 sm:text-xs" data-id="element-204" data-mp="2y7hghj1y7ual">
              {stat.label}
            </span>
          </li>)}
      </ul>
    </section>;
}